__turbopack_context__.v({
  "className": "inconsolata_533a674f-module__Zi8M5G__className",
});
